import { EMPTY } from 'rxjs';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DocumentType } from '../../../enums/document-type';
import { messages } from '../messages';

export const hotkeysAndBarcode = {
  id: DocumentType.HotkeysAndBarcode.identifier,

  getDownloadStartedProps: () => ({
    title: <FormattedMessage {...messages.downloadHotkeysAndBarcodeStartedTitle} />,
    content: <FormattedMessage {...messages.downloadHotkeysAndBarcodeStartedContent} />,
  }),

  getDownloadCompletedProps: () => ({
    title: <FormattedMessage {...messages.downloadHotkeysAndBarcodeCompletedTitle} />,
    content: <FormattedMessage {...messages.downloadHotkeysAndBarcodeCompletedContent} />,
  }),

  getPrintedSuccessNotificationProps: (printerName) => ({
    title: <FormattedMessage {...messages.printingHotkeysAndBarcodeSuccessTitle} />,
    content: <FormattedMessage {...messages.printingHotkeysAndBarcodeSuccessContent} values={{ printerName }} />,
  }),

  getPrintedSuccessObservable: () => {
    return EMPTY;
  },
};
